export default "__VITE_ASSET__CYDtsej1__"